var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import produce from 'immer';
import DocumentComparisonApi from '~/api/document-comparison-view';
import FileTransferApi from '~/api/file-transfer';
import convertB64StringToByteArray from '~/utils/convertB64StringToByteArray';
export const getComparisonDocumentsById = createAsyncThunk('comparisonDocuments/getDocumentsById', (payload_1, _a) => __awaiter(void 0, [payload_1, _a], void 0, function* (payload, { dispatch, rejectWithValue }) {
    const { documentComparisonId, ws } = payload;
    try {
        const response = yield new Promise(resolve => {
            ws.send('request:/document-comparison-view:get', { documentComparisonId }, data => resolve(data));
        });
        if (response.statusCode !== 200) {
            const error = {
                name: 'Websocket Error',
                message: 'Failed to get document comparison',
            };
            window.routeToErrorPage(error, JSON.stringify(response.payload));
        }
        else {
            const comparisonDocuments = response.payload;
            comparisonDocuments.sort((a, b) => a.orderIndex < 0 && b.orderIndex >= 0
                ? 1
                : b.orderIndex < 0 && a.orderIndex >= 0
                    ? -1
                    : a.orderIndex - b.orderIndex);
            return { comparisonDocuments, documentComparisonId };
        }
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const fetchComparisonPdfs = createAsyncThunk('comparisonDocuments/fetchComparisonPdfs', (payload_1, _a) => __awaiter(void 0, [payload_1, _a], void 0, function* (payload, { rejectWithValue }) {
    var _b;
    const { comparisonDocuments } = payload;
    try {
        const jsonBlobs = yield Promise.all(comparisonDocuments.map(compareDoc => FileTransferApi.get(compareDoc.fileUrl.fileTransferUrl)));
        if (jsonBlobs.length !== comparisonDocuments.length) {
            rejectWithValue(new Error('Failed to download all files'));
        }
        const blobList = [];
        for (let i = 0; i < comparisonDocuments.length; i++) {
            const text = yield ((_b = jsonBlobs[i]) === null || _b === void 0 ? void 0 : _b.text());
            if (text) {
                const byteCharacters = atob(yield JSON.parse(text).data);
                const byteArray = yield convertB64StringToByteArray(byteCharacters);
                blobList.push(new Blob([byteArray], {
                    type: 'application/pdf',
                }));
            }
        }
        const newComparisonDocs = produce(comparisonDocuments, draft => {
            for (let i = 0; i < blobList.length; i++) {
                draft[i].blob = blobList[i];
            }
        });
        return { comparisonDocuments: newComparisonDocs };
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const getOrCreateDocumentComparison = createAsyncThunk('comparisonDocuments/getOrCreate', (payload_1, _a) => __awaiter(void 0, [payload_1, _a], void 0, function* (payload, { dispatch, rejectWithValue }) {
    const { fileIds, ws, navigate } = payload;
    let documentComparison;
    try {
        const response = yield new Promise(resolve => {
            ws.send('request:/document-comparison-view:post', { fileIds }, data => resolve(data));
        });
        if (response.statusCode !== 200) {
            const error = {
                name: 'Websocket Error',
                message: 'Failed to create document comparison',
            };
            window.routeToErrorPage(error, JSON.stringify(response.payload));
        }
        else {
            documentComparison = response.payload;
        }
    }
    catch (error) {
        return rejectWithValue(error);
    }
    navigate(`/compare/${documentComparison.documentComparisonId}`);
    return documentComparison === null || documentComparison === void 0 ? void 0 : documentComparison.payload;
}));
export const addComment = createAsyncThunk('comparisonDocuments/addCommentToClause', (_a) => __awaiter(void 0, [_a], void 0, function* ({ classificationId, documentComparisonFileId, text, privilegeGroups, taggedUserIds, }) {
    return DocumentComparisonApi.addComment({
        classificationId,
        documentComparisonFileId,
        text,
        privilegeGroupIds: privilegeGroups,
        taggedUserIds,
    });
}));
export const updateComment = createAsyncThunk('comparisonDocuments/updateComment', (_a) => __awaiter(void 0, [_a], void 0, function* ({ commentId, commentText }) {
    return DocumentComparisonApi.updateComment({
        commentId: commentId,
        text: commentText,
    });
}));
export const deleteComment = createAsyncThunk('comparisonDocuments/deleteComment', (_a) => __awaiter(void 0, [_a], void 0, function* ({ commentId }) {
    return DocumentComparisonApi.deleteComment({ commentId });
}));
